import React, { useState, useEffect, PureComponent, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { SiHyperledger } from "react-icons/si";
import "jspdf-autotable";
import DataGridComponent from '../../Components/DataGridComponent';
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import DataGridShowDetails from "../../Components/DataGridShowDetails";
import { errorAlert } from "../../Components/Alerts";
import { AddActionsButton } from "../../Components/AddElementsButton";
import { AiOutlineClose } from "react-icons/ai";
import ExcelFormat from "../../Components/ExcelConverter/ExcelFormat";
import { financialDetailColumns, financialDetailMappings } from "../../Components/ExcelConverter/FinancialStatement";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";
import { ArticleCardGridHeader, ArticleDetailsColumns, ArticleDetailsGrid, ArticleDetailsMappings, sinteticArticleColumns, sinteticArticleMappings } from "./GridHeaders/ArticleCardGrid";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function KartelaArtikullit() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);
    const [articleDetails, setArticleDetails] = useState([]);

    const [showallAccounts, setShowAllAccounts] = useState(true);
    const [showDetailAccounts, setShowDetailsAccounts] = useState(false);

    const [articleName, setArticleName] = useState("");

    const [articleDetailsChart, setArticleDetailsChart] = useState([]);

    const fetchMaterialSintetikData = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/articleSyntheticAnalysis', {
                headers,
                params: { fiscalYear: fiscalYear }
            });
            setData(response.data);
            // setShowOtherTable(false);
            // console.log(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response?.data?.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë.");
            }
        }
    };

    const total = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [data]);

    const vleraNeEu = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.VleraNeEuro), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        barcode: item.Barcode,
        articleName: item.ArticleName,
        jan: item.Janar,
        feb: item.Shkurt,
        mar: item.Mars,
        apr: item.Prill,
        may: item.Maj,
        jun: item.Qershor,
        jul: item.Korrik,
        aug: item.Gusht,
        sep: item.Shtator,
        oct: item.Tetor,
        nov: item.Nentor,
        dec: item.Dhjetor,
        tot: item.Total,
        avg: item.CmimiMesatar,
        valEu: item.VleraNeEuro,

        showDetails: item.ArticleID,
        rowInfo: item
    }));

    const totalDetails = useMemo(() => {
        return articleDetails.reduce((sum, item) => sum + Number(item.Total), 0);
    }, [articleDetails]);

    const vleraNeEuDetails = useMemo(() => {
        return articleDetails.reduce((sum, item) => sum + Number(item.VleraNeEuro), 0);
    }, [articleDetails]);


    const detailsRows = articleDetails.map((item, index) => ({
        id: ++index,
        barcode: item.Barcode,
        articleName: item.ArticleName,
        accountName: item.AccountName,
        jan: item.Janar,
        feb: item.Shkurt,
        mar: item.Mars,
        apr: item.Prill,
        may: item.Maj,
        jun: item.Qershor,
        jul: item.Korrik,
        aug: item.Gusht,
        sep: item.Shtator,
        oct: item.Tetor,
        nov: item.Nentor,
        dec: item.Dhjetor,
        tot: item.Total,
        avg: item.CmimiMesatar,
        valEu: item.VleraNeEuro,
    }));

    const fetchArticleDetails = async (idNumber, fiscalY) => {
        showDetails();
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/articleDetails', { headers, params: { articleID: idNumber, fiscalYear: fiscalY } });
            setArticleDetails(response.data);
            setArticleName(response.data[0].ArticleName)
            fetchArticleDetailsForChart(idNumber, fiscalYear);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const fetchArticleDetailsForChart = async (idNumber, fiscalY) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'Card/articleDetailsChart', { headers, params: { articleID: idNumber, fiscalYear: fiscalY } });
            // setArticleDetails(response.data);
            // setArticleName(response.data[0].ArticleName)
            console.log(response.data);
            setArticleDetailsChart(response.data.MonthlyData);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message}`);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };
    const monthNames = [
        "Janar", "Shkurt", "Mars", "Prill", "Maj", "Qershor",
        "Korrik", "Gusht", "Shtator", "Tetor", "Nëntor", "Dhjetor"
    ];

    function getMonthName(monthNumber) {
        return monthNames[monthNumber - 1] || "";
    }

    const showDetails = () => {
        setShowAllAccounts(false);
        setShowDetailsAccounts(true);
    }

    const showAllAccounts = () => {
        setShowAllAccounts(true);
        setShowDetailsAccounts(false);
        setArticleDetails([]);
    }

    useEffect(() => {
        fetchMaterialSintetikData();
    }, [fiscalYear]);

    return (
        <div className="Crud__Container">
            {showallAccounts && (
                <>
                    <TitleElements
                        icon={SiHyperledger}
                        title="Kartela sintetike e artikujve"
                    />
                    <hr></hr>
                    <ExcelFormat
                        data={data}
                        fileName={`Kartela sintetike e artikujve`}
                        columns={sinteticArticleColumns}
                        columnMappings={sinteticArticleMappings}
                        buttonText="XLSX"
                    />

                    <DataGridShowDetails
                        columns={ArticleCardGridHeader}
                        rows={rows}
                        fetchAccountsDetails={fetchArticleDetails}
                        height={500}
                    />
                    <TotalSummaryComponent
                        fields={[
                            { id: 1, label: 'Total', value: total },
                            { id: 2, label: 'Vlera në euro', value: vleraNeEu },
                        ]}
                    />
                </>
            )}

            {showDetailAccounts && (
                <>
                    <TitleElements
                        icon={SiHyperledger}
                        // title="Artikulli në Detale"
                        title={`Historiku i artikullit: ${articleName}`}
                    />
                    <br></br>
                    <div style={{ display: "flex", justifyContent: "flex-end" }}>
                        <div className="butons15">
                            <AddActionsButton
                                text="Mbyll"
                                onClick={showAllAccounts}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div>
                    </div>

                    <div >
                        <ResponsiveContainer width="100%" height={500}>
                            <BarChart
                                width={500}
                                height={500}
                                data={articleDetailsChart} // ky është articleDetailsChart

                            >
                                <CartesianGrid strokeDasharray="5 5" />
                                <XAxis dataKey="MonthNumber" />
                                <YAxis />
                                <Tooltip
                                    labelFormatter={(label) => `Muaji: ${getMonthName(label)}`}
                                />
                                <Legend />
                                <Bar dataKey="MonthQty" fill="#8884d8" name="Sasia" barSize={15} />
                                <Bar dataKey="MonthValue" fill="#82ca9d" name="Vlera" barSize={15} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <br></br>
                    <div className="bordere">
                        <ExcelFormat
                            data={articleDetails}
                            fileName={`${articleName}-Detale`}
                            columns={ArticleDetailsColumns}
                            columnMappings={ArticleDetailsMappings}
                            buttonText="XLSX"
                        />

                        {/* <div className="butons15">
                            <AddActionsButton
                                text="Mbyll"
                                onClick={showAllAccounts}
                                icon={<AiOutlineClose />}
                                className="button-15"
                            />
                        </div> */}

                    </div>
                    <DataGridComponent columns={ArticleDetailsGrid} rows={detailsRows} />
                    <TotalSummaryComponent
                        fields={[
                            { id: 1, label: 'Total', value: totalDetails },
                            { id: 2, label: 'Vlera në euro', value: vleraNeEuDetails },
                        ]}
                    />
                </>

            )}
        </div>
    )
}